export default class InvestorsOtherDocsList {
    constructor() {
        this.section = document.querySelector('.components-block-investors-other-docs-list');
        this.ready();
    }

    ready() {
        const unitSelector = this.section.querySelector('.unit-selector');
        const yearSelector = this.section.querySelector('.year-selector');
        const trimesterSelector = this.section.querySelector('.trimester-selector');
        const typeSelector = this.section.querySelector('.type-selector');
        const url = new URL(window.location.href);

        const keys = ['unit', 'year', 'trimester', 'type'];
        const selectors = [unitSelector, yearSelector, trimesterSelector, typeSelector];

        const redirect = () => {
            let hasChanged = false;

            selectors.forEach((selector, index) => {
                if (selector) {
                    // Verifica se o valor do seletor é diferente do valor atual na URL
                    if (url.searchParams.has(keys[index]) && url.searchParams.get(keys[index]) !== selector.value) {
                        hasChanged = true;
                    }

                    url.searchParams.set(keys[index], selector.value);
                }
            });

            if (url.searchParams.has('page')) {
                // Se houve alteração nos filtros, volta para a primeira página
                url.searchParams.set('page', hasChanged ? 1 : url.searchParams.get('page'));
            }

            url.hash = this.section.id;
            window.location.href = url.href;
        };

        selectors.forEach((selector, index) => {
            if (selector) {
                selector.value = url.searchParams.get(keys[index]) || '';
                selector.addEventListener('change', redirect);
            }
        });

        const pagination = this.section.querySelector('[role="navigation"]');
        if (pagination) {
            pagination.addEventListener('click', (event) => {
                if (event.target.tagName === 'A') {
                    event.preventDefault();
                    const linkUrl = new URL(event.target.href);
                    url.searchParams.set('page', linkUrl.searchParams.get('page'));
                    redirect();
                }
            });
        }
    }
}

if (document.querySelector('.components-block-investors-other-docs-list')) {
    new InvestorsOtherDocsList();
}
